var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApacheAirflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.5441 127 60.809-62.332a1.124 1.124 0 0 0 0.1359-1.4368c-3.6977-5.1625-10.521-6.0578-13.05-9.5268-7.4903-10.275-9.3909-16.092-12.61-15.731a0.98374 0.98374 0 0 0-0.58464 0.3085l-21.966 22.518c-12.638 12.944-14.454 41.475-14.782 65.367a1.1908 1.1908 0 0 0 2.0473 0.83273z",
    fill: "#6600ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m126.99 125.46-62.332-60.813a1.124 1.124 0 0 0-1.4389-0.1359c-5.1625 3.6998-6.0578 10.521-9.5268 13.05-10.275 7.4903-16.092 9.3909-15.731 12.61a0.98374 0.98374 0 0 0 0.3085 0.58248l22.518 21.966c12.944 12.638 41.475 14.454 65.367 14.782a1.1908 1.1908 0 0 0 0.83489-2.0408z",
    fill: "#6600ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m60.792 112.72c-7.076-6.9035-10.355-20.559 3.2058-48.719-22.046 9.8525-29.771 22.803-25.972 26.511z",
    fill: "#dde3dd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m125.45 1.0113-60.807 62.332a1.1218 1.1218 0 0 0-0.1359 1.4368c3.6998 5.1625 10.519 6.0578 13.05 9.5268 7.4903 10.275 9.393 16.092 12.61 15.731a0.97943 0.97943 0 0 0 0.58464-0.3085l21.966-22.518c12.638-12.944 14.454-41.475 14.782-65.367a1.193 1.193 0 0 0-2.0495-0.83273z",
    fill: "#6600ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m112.73 67.211c-6.9035 7.076-20.559 10.355-48.721-3.2058 9.8525 22.046 22.803 29.771 26.511 25.972z",
    fill: "#dde3dd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m1.0017 2.5495 62.332 60.807a1.124 1.124 0 0 0 1.4368 0.1359c5.1625-3.6998 6.0578-10.521 9.5268-13.05 10.275-7.4903 16.092-9.3909 15.731-12.61a0.99022 0.99022 0 0 0-0.3085-0.58463l-22.518-21.966c-12.944-12.638-41.475-14.454-65.367-14.782a1.1908 1.1908 0 0 0-0.83273 2.0495z",
    fill: "#6600ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m67.212 15.284c7.076 6.9035 10.355 20.559-3.2058 48.721 22.046-9.8525 29.771-22.805 25.972-26.511z",
    fill: "#dde3dd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m15.279 60.8c6.9035-7.076 20.559-10.355 48.721 3.2058-9.8525-22.046-22.803-29.771-26.511-25.972z",
    fill: "#dde3dd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.009,
    cy: 63.995,
    r: 2.7182,
    fill: "#4a4848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApacheAirflow);
export default __webpack_public_path__ + "static/media/Apache Airflow.46f9a5e7036a89f3f84b7d7c3cd1a7b3.svg";
export { ForwardRef as ReactComponent };